import schema from "./schema/index";

function parsePath(path, ignoreEnd = 0) {
  if (path.length > 2 && path[0] == "*" && path[1] == "/")
    path = path.substr(2);

  const parts = path.split("/");
  const route = [];
  let collectionSet = schema.collections;
  const processedParts = [];

  for (let i = 0; i < parts.length - ignoreEnd; i++) {
    const collectionName = parts[i];
    processedParts.push(collectionName);
    const collection = collectionSet[collectionName] || collectionSet["*"];

    if (!collection) return null;

    route.push({
      collection: { ...collection, name: collectionName },
      collectionRef: processedParts.join("/"),
    });

    i++;
    if (i >= parts.length) break;

    const objectTypeName = collection.objectType;
    const objectType = schema.objectTypes[objectTypeName];
    const objectRef = parts[i];
    processedParts.push(objectRef);

    route.push({
      objectType: { ...objectType, name: objectTypeName },
      objectRef: processedParts.join("/"),
    });

    collectionSet = objectType.collections;
  }

  return route;
}

export default parsePath;
